function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "inherit",
  stroke: "currentColor",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M.2.2h11.4v7.9H.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.2.2L6 4.9 11.7.2"
}));

function SvgMeddelaMigFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.9 8.4"
  }, props), _ref);
}

export default SvgMeddelaMigFill;